export default "__VITE_ASSET__BKlDxU5H__"